import { authMechanismAtom } from '@/context/atoms/AuthMechanism';
import { singletonAtom } from '@/context/atoms/helper/singletonAtom';
import { publicConfigAtom } from '@/context/atoms/publicConfig';
import { SESSION_STORAGE_KEY } from '@/context/atoms/Session';
import { browserSessionOptions, HttpApiSdk, ReLoginAllowed } from '@ekkogmbh/apisdk';

// One SDK per page: two instances on the same storage key in one document
// cannot see each other's session changes.
export const apiSdkAtom = singletonAtom<Promise<HttpApiSdk>>(async (get) => {
  const publicConfig = await get(publicConfigAtom);
  const authMechanism = await get(authMechanismAtom);

  return new HttpApiSdk(
    publicConfig.env.BACKEND_URL,
    authMechanism,
    true,
    undefined,
    ReLoginAllowed.NO,
    browserSessionOptions({ storageKey: SESSION_STORAGE_KEY }),
  );
});
